import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const SharePointOutline: React.FC<Props> = ({ width, height, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
    >
      <g fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M13.23 4L4 5.77v12.46L13.23 20V4zm1.232 2.462c-.217 0-.424.045-.616.115v3.461c.192.07.4.116.616.116.682 0 1.276-.373 1.596-.923.488.279.894.685 1.173 1.173-.55.32-.923.913-.923 1.596s.372 1.276.923 1.596c-.28.488-.685.894-1.173 1.173-.32-.55-.914-.923-1.596-.923-.217 0-.424.046-.616.116v3.461c.192.067.4.115.616.115.992 0 1.805-.786 1.846-1.769.834-.41 1.512-1.089 1.923-1.923C19.214 13.806 20 12.993 20 12c0-.993-.786-1.805-1.77-1.846-.41-.834-1.088-1.512-1.922-1.923-.041-.983-.854-1.77-1.846-1.77zM8.538 8.846c.318 0 .601.02.847.058.245.038.466.094.673.173v1.27c-.101-.07-.207-.14-.327-.193-.12-.053-.257-.099-.385-.135-.127-.036-.24-.06-.365-.077s-.253-.019-.366-.019c-.156 0-.295.01-.423.039-.127.03-.24.081-.327.134-.086.053-.144.118-.192.192-.048.075-.077.157-.077.25 0 .101.024.188.077.27.053.081.132.158.23.23.1.073.224.142.366.212s.303.14.481.212c.243.1.46.211.654.326.195.116.36.24.5.385.14.144.233.315.308.5.074.185.115.406.115.654 0 .339-.063.615-.192.846-.13.23-.298.416-.52.558-.22.142-.476.245-.769.307-.293.063-.618.097-.942.097-.334 0-.642-.02-.942-.077-.3-.058-.568-.157-.789-.27v-1.346c.245.207.52.358.808.462.288.103.57.154.865.154.173 0 .332-.008.462-.039s.24-.08.327-.134c.086-.056.151-.118.192-.193.04-.074.058-.163.058-.25 0-.117-.03-.233-.097-.327-.067-.093-.17-.17-.288-.25-.118-.079-.262-.158-.423-.23-.161-.075-.332-.154-.52-.231-.475-.197-.824-.426-1.057-.712-.233-.286-.346-.634-.346-1.038 0-.317.065-.599.192-.827.128-.228.3-.411.52-.558.22-.146.46-.257.75-.327.288-.07.6-.096.922-.096z"
            transform="translate(-158 -292) translate(126 23) translate(32 220) translate(0 49)"
          />
        </g>
      </g>
    </svg>
  );
};

export default SharePointOutline;
